
(window as any).eval = function(...args: any[]) {
  console.log('Window.eval is forbidden, this variable', this, 'args:', args)
  throw new Error(['Window.eval is forbidden, this variable', this, 'args:', args].join(', '))
}

export default true
